import { Component, OnInit, ViewChild, ElementRef }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IScenario, ScenarioService, CreateScenarioRequest, CreateScenarioResponse } from './scenario.service';
import { UserSession } from '../shared/user-session';
import { Dialog } from 'primeng/primeng';
import {Messages} from 'primeng/primeng';


@Component({
    template: require('./scenario-create.component.html'),
    styles: [require('../styles/faa_styles.css')],
    directives: [ROUTER_DIRECTIVES, Dialog],
})

export class ScenarioCreateComponent implements OnInit {
    pageTitle: string = 'Create a Scenario';
    errorMessage: string;
    currentScenario: IScenario;
    allScenarios: IScenario[];
    nameTextInput: HTMLInputElement;
    displaySpinner :boolean=false;
    msgs: Messages[]=[];

    constructor(private route: ActivatedRoute,
        private router: Router,
        private request: CreateScenarioRequest,
        private _scenarioService: ScenarioService,
        private _User: UserSession
    ) { }

    @ViewChild('scenarioName') scenarioName: ElementRef;

    ngOnInit(): void {
        this.displaySpinner = false;

        if(typeof(this._User.scenarioId) === 'undefined')
            this.router.navigate(['./scenario-activities']);

        this.nameTextInput = this.scenarioName.nativeElement;

        // Make a single call to get all scenarios to populate the dropdown and also 
        // filter out the current scenario to display in the header
        this._scenarioService.getScenarios(this._User.getSession()['id'])
            .subscribe(
            allScenarios => this.allScenarios = allScenarios,
            error => this.errorMessage = <any>error,
            () => {
                this.currentScenario = this.allScenarios.filter(function (el: IScenario) {
                    return el.id === this._User.getSession().scenarioId;
                }.bind(this))[0];
                this.request.baseScenarioId = this.allScenarios[0].id;  
            });
        this.request.userId = this._User.userId;
        this.request.public = false;
        
    }

    onNameChange(): void {
        // Verify that the name doesn't already exist
        if(this.scenarioNameExists(this.nameTextInput.value))
            return;

        this.request.scenarioName = this.nameTextInput.value;
    }

    onSelectChange(event: Event): void {
        let select: HTMLSelectElement = event.target as HTMLSelectElement;
        this.request.baseScenarioId = +select.value
    }

    onCheckboxChange(event: Event): void {
        let checkbox: HTMLInputElement = event.target as HTMLInputElement;
        this.request.public = checkbox.checked;
    }

    selectFacilities(): void {
        if(this.scenarioNameExists(this.nameTextInput.value))
            return;
        
        this.request.source = "filtered";
        this.request.facilities = [];
        
        // Set request in session storage to prevent data loss on browser refresh
        //sessionStorage.setItem('create-scenario-request', JSON.stringify(this.request));
        this.request.updateSessionState();

        this.router.navigate(['./scenario-select-facilities']);        
    }

    createWithAllFacilities(): void {
       
        if(this.scenarioNameExists(this.nameTextInput.value))
            return;

        this.request.source = "all";
        this.displaySpinner = true;     
        this._scenarioService.createScenario(this.request)
            .subscribe(
                (response:CreateScenarioResponse) =>{
                    if(response.responseStatus === 'ERROR'){
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Error Message', detail: response.responseMessage});            
                        this.displaySpinner = false;
                        return;
                    }
                    this.displaySpinner = false;
                    this.router.navigate(['./scenario-create-results']);
                },
                error => this.errorMessage = <any>error                
            );
    }

    cancel(): void {
        this.router.navigate(['./scenario-activities']);
    }

    private scenarioNameExists(name: string): boolean {
        if(!name){
            this.msgs=[];
            this.msgs.push({severity:'error', summary:'Error Message', detail: 'Please fix the following error: Scenario Name exists or is empty'});
            return true;
        }
        var found = this.allScenarios.filter(function (el: IScenario) {
            return el.scenarioName === name;
        }.bind(this));

        if (found.length > 0) {
            this.msgs=[];
            this.msgs.push({severity:'error', summary:'Error Message', detail: 'Please fix the following error: Scenario Name exists or is empty'});
            //alert('A scenario with that name has already been created. Please enter another name.')
            this.nameTextInput.value = '';
            return true;
        }
        return false;
    }
}


/** WEBPACK FOOTER **
 ** ./app/scenario-activities/scenario-create.component.ts
 **/